const enum BannerNotificationStylesEnum {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Promo = 'promo',
  Success = 'success',
}

export default BannerNotificationStylesEnum;
